import { createContext, FC, useMemo, useState, useEffect } from 'react'
import { useCurrentUserQuery } from '@foros-fe/graphql'

const initialState: {
  selected: string | null
  setSelected(id: string | null): void
  currentUserId: undefined | string
} = {
  selected: null,
  setSelected: () => {},
  currentUserId: undefined,
}

const Context = createContext(initialState)
export default Context

export const AuctionListContextProvider: FC = ({ children }) => {
  const [state, setState] = useState(initialState)
  const { data } = useCurrentUserQuery({ fetchPolicy: 'cache-first' })

  useEffect(() => {
    setState((state) => ({
      ...state,
      currentUserId: data?.currentUser?.id,
    }))
  }, [data])

  const value = useMemo(
    () => ({ ...state, setSelected: (selected: string) => setState({ ...state, selected }) }),
    [state]
  )

  return <Context.Provider value={value}>{children}</Context.Provider>
}
